<template>
<Dialog :header="header" 
v-model:visible="show_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '80vw'}"
:modal="true"
>

<div class="grid mt-4" >

<div class="col-12 mb-2 py-1" >
<p  v-for="verification in verifications">
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Verification', params: { id: verification.id }}" target="_blank">

  	{{verification.flowsupplier.flow.name}}  
  	<span class="ml-4">
  		<template v-if="verification.status=='awaiting_schedule'">
		<Tag 
		class="mt-1 custom-chip ml-0" 
		:value="$store.state.languages.lang_phrases.planlama_bekliyor" 
		style="background-color:#352f8d"
		/>
		</template> 

		<template v-if="verification.status=='scheduled'">
		<Tag 
		class="ml-0 mt-1 custom-chip" 
		:value="$store.state.languages.lang_phrases.planlandi" 
		style="background-color:#7e2f8d"
		/>
		</template> 

		<template v-if="verification.status=='completed'">
		<Tag 
		class="ml-0 mt-1 custom-chip" 
		:value="$store.state.languages.lang_phrases.tamamlandi0" 
		style="background-color:#4dc247"
		/>
		</template> 

		<template v-if="verification.status=='canceled'">
		<Tag 
		class="ml-0 mt-1 custom-chip" 
		:value="$store.state.languages.lang_phrases.iptal_edildi" 
		style="background-color:#a82400"
		/>
		</template> 

		<template v-if="verification.status=='rescheduled'">
		<Tag 
		class="ml-0 mt-1 custom-chip" 
		:value="$store.state.languages.lang_phrases.tekrar_planlandi" 
		style="background-color:#ff6600"
		/>
		</template>

		<template v-if="verification.status=='on_planning'">
		<Tag 
		class="ml-0 mt-1 custom-chip" 
		:value="$store.state.languages.lang_phrases.planlamada" 
		style="background-color:#3b82f6"
		/>
		</template> 

  	</span>
  	<span class="ml-4">
  		{{ $filters.momentFormat( verification.scheduled_at," Do-MM-YYYY dddd")}}
  	</span>
  	<span class="ml-4" v-if="verification.status=='scheduled' || verification.status=='rescheduled'">
  		{{verification.auditor.user.name}}
  	</span>


  </router-link>
</p>
</div>

</div>


<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>



</template>
</Dialog>
</template>

<script>
export default {

  name: 'OtherVerificationsModal',
  props:["verifications","supplier"],
  computed:{
  	header()
  	{
  		return this.supplier.name + " tedarikçisinin diğer doğrulama görüşmeleri"
  		
  	},
  },
  data () {
    return {
    	show_modal:false,
    }
  },
  methods:{
  	showModal()
  	{
  		
  		this.show_modal = true  		
  	},
  	hideModal()
  	{
  		this.show_modal = false
  	},

  },
}
</script>

<style lang="css" scoped>
</style>